import { Injectable } from '@angular/core';
import { LoginApiService } from './api/login-api.service';
import { HttpWrapperService } from './api/http-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private loginApiService: LoginApiService, private dashboardHttpService: HttpWrapperService) {
  }

  /**
   * The route /logout is a convenience to logout by just hitting a url if the UI logout button is unavailable, otherwise
   * we can call the logout() method directly.
   */
  logout(displaySessionTimeout = false): void {
    this.loginApiService.logout().subscribe(
      {
        next: () => {
          this.dashboardHttpService.removeAuthAndFullNavLogout(displaySessionTimeout);
        },
        error: () => {
          this.dashboardHttpService.removeAuthAndFullNavLogout(displaySessionTimeout);
        }
      });
  }
}
